import React, { useState, useEffect } from 'react';
import { Typography, Row, Col, Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import form from 'antd/es/form';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { IChangePassword, IResetPassword } from '../../../models/loginRequest';
import { changePassword } from '../authApi';
import { RootState, useAppDispatch } from '../../../app/store';
import { useSelector } from 'react-redux';
import { fetchUsers } from '../../setup/user-management/usersApi';
import { NOTIFICATION_TYPES } from '../../../utils/constant';
import { notification } from 'antd';

const { Title, Paragraph } = Typography;

const ChangePassword: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { loginUser } = useSelector((state: RootState) => state.auth);
    const [loading, setLoading] = useState(false);
    const dispatch = useAppDispatch();
    const [operationSuccessMessages, setOperationSuccessMessage] = useState({ title: '', description: '' });
    const [form] = Form.useForm();
    useEffect(() => {
        dispatch(fetchUsers());
    }, [dispatch]);


    //Handle click event of reset password button
    const onFinish = (values: any) => {
        setLoading(true);
        const changePasswordRequest: IChangePassword = {
            email: loginUser.user.email,
            old_password: values.currentPassword,
            password: values.newPassword,
            password_confirmation: values.confirmPassword
        };

        //Trigger api call for change password
        dispatch(changePassword(changePasswordRequest))
            .unwrap()
            .then((response) => {
                setLoading(false);
                if (response?.status === 'success') {
                    setOperationSuccessMessage({
                        title: t('change-password.response.success.title'),
                        description: t('change-password.response.success.desc')
                    });
                    notification[NOTIFICATION_TYPES.SUCCESS]({ message: t('success'), description: t('change-password.response.success.desc') });

                    navigate(`/login`);
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Failed to change password:', error);
            });
    }


    return (
        <Row justify="center">
            <Col span={10}>
                <Form
                    name="login"
                    form={form}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}

                    layout="vertical"
                    style={{ height: '100%', margin: '5% 15%', textAlign: 'left' }}>

                    <h3 className="login-title" style={{ margin: '0 0 25px 0' }}>
                        {t('login.change-password.title')}
                    </h3>

                    <Form.Item
                        label={t('old-password')}
                        name="currentPassword"
                        rules={[{ required: true, message: t("password.old.required.msg") },]}
                    >
                        <Input.Password
                            placeholder={t('old-password.placeholder')}
                            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            className="login-input" />
                    </Form.Item>

                    <Form.Item
                        label={t('new-password')}
                        name="newPassword"
                        rules={[{ required: true, message: t("password.new.required.msg") },]}

                    >
                        <Input.Password
                            placeholder={t('new-password.placeholder')}
                            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            className="login-input" />
                    </Form.Item>

                    <Form.Item
                        label={t('confirm-new-password')}
                        name="confirmPassword"
                        dependencies={['newPassword']}
                        rules={[{ required: true, message: t("password.confirm.required.msg") },]}
                    >
                        <Input.Password
                            placeholder={t('confirm-new-password.placeholder')}
                            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            className="login-input" />
                    </Form.Item>
                    <Form.Item>
                        <Row justify="center" gutter={12}>
                            <Col span={12} >
                                <Button type="primary" htmlType="submit" block
                                    loading={loading}
                                    className="login-button">
                                    {t('login.change-password.title')}
                                </Button>
                            </Col>
                            <Col span={12}>
                                <Button type="primary" onClick={(e) => navigate(`/home`)} htmlType="submit" block
                                    // loading={props.loading} 
                                    className="login-button">
                                    {t('btn.cancel')}
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Col>
        </Row>
    );
};

export default ChangePassword;